import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { StrapiService } from '../services/strapi.service';
import { catchError, map, of } from 'rxjs';

export const pageResolver: ResolveFn<any> = (route, state) => {
  const strapi = inject(StrapiService);
  const page = route.paramMap.get('page');

  const router = inject(Router);


  return strapi.getPage(page!).pipe(
    map(pageData => {
      // Check if page data exists (not null/undefined/empty)
      if (!pageData) {
        router.navigate([`/not-found`]);
        return null;
      }
      return pageData;
    }),
    catchError(error => {
      // Handle API errors by navigating to not-found page
      router.navigate([`/not-found`]);
      return of(null);
    })
  );
};
